export const FOX_TOKEN_CONTRACT_ADDRESS = '0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d'
export const WETH_TOKEN_CONTRACT_ADDRESS = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'
export const UNIV2_WETH_FOX_POOL_ADDRESS = '0x470e8de2ebaef52014a47cb5e6af86884947f08c'
export const UNISWAP_WETH_FOX_FARMING_REWARDS_V4_ADDRESS =
  '0x24fd7fb95dc742e23dc3829d3e656feeb5f67fa0'
export const TRADING_FEE_RATE = 0.003
